module.exports = "<div class=\"menubt\" (click)=\"toggleHideFilter()\">\r\n\t<span class=\"fa fa-bars\"></span>\r\n</div>\r\n\t\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/html/pageHeader.html
// module id = 685
// module chunks = 1